import L from "leaflet"
import "leaflet-fullscreen"
import { isUndefined } from "lodash"
import Vue from "vue"
import Component from "vue-class-component"
import { LIcon, LMap, LMarker, LPopup, LTileLayer } from "vue2-leaflet"

delete (L.Icon.Default.prototype as any)._getIconUrl

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
})

const TRY_INTERVAL = 300
const MAX_TRIES = 30

@Component({
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LIcon,
        LPopup,
    },
})
export default class Map extends Vue {
    protected markerOptions: L.MarkerOptions = { autoPan: true }
    protected iconSize: number[] = [34, 34]
    protected iconAnchor: number[] = [15, 36]
    protected popupAnchor: number[] = [0, -34]
    protected tooltipAnchor: number[] = [17, -17]
    protected center: L.LatLng = L.latLng(41.818213, -87.665712)
    protected latLng: L.LatLng = L.latLng(41.818213, -87.665712)
    protected smallZoom = 9
    protected middleZoom = 18
    protected maxZoom = 23
    protected options: any = {
        maxZoom: 23,
        tileSize: 512,
        zoomOffset: -1,
        // id: "fkruta/ckfns6qac02rx19mpue5hfjdx",
        id: "mapbox/light-v10",
        accessToken:
            "pk.eyJ1IjoiZmtydXRhIiwiYSI6InZLQXp0LXMifQ.IzN6KCblMOhYUoTydg80ug",
    }
    protected url = process.env.VUE_APP_TILE_SERVER_URL
    protected attribution =
        '&copy; <a href="http://www.mapbox.com/about/maps/" target="_blank">Terms &amp; Feedback</a>'

    protected onMapLoad(tryCount: number) {
        if (
            isUndefined(this.$refs.map) ||
            isUndefined((this.$refs.map as any).mapObject)
        ) {
            if (tryCount < MAX_TRIES) {
                setTimeout(() => this.onMapLoad(tryCount + 1), TRY_INTERVAL)
            }
            return
        }

        const Map = (this.$refs.map as any).mapObject

        Map.zoomControl.setPosition("bottomright")
        Map.addControl((L.control as any).fullscreen({ position: "topleft" }))
    }

    protected mounted() {
        this.onMapLoad(0)
    }

    protected activated() {
        if (isUndefined(this.$refs.map)) {
            return
        }

        ;(this.$refs.map as any).mapObject.invalidateSize()
    }
}
